<div class="login-body">
    <div class="login-panel surface-card p-4 shadow-2 border-round w-full lg:w-4">
        <div class="text-center mb-5">
            <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" height="100h" class="mb-3">
            <div class="text-900 text-3xl font-medium mb-3 uppercase">Cargando vista para {{currentUser.initials}}</div>
            <p-progressBar mode="indeterminate"></p-progressBar>
        </div>
        <div>
            <button pButton pRipple
                    type="button" 
                    label="{{'Recargar'}}"
                    icon="pi pi-refresh" class="w-full"
                    (click)="irAInicio($event)">
            </button>
        </div>
    </div>
</div>